import { render, staticRenderFns } from "./manage-ivr.vue?vue&type=template&id=259ea8d1&"
import script from "./manage-ivr.vue?vue&type=script&lang=js&"
export * from "./manage-ivr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports